import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AuthService } from '../core/auth.service';
import { ItemService } from '../services/item.service';

@Component({
  selector: 'app-query-form',
  templateUrl: './query-form.component.html',
  styleUrls: ['./query-form.component.css']
})
export class QueryFormComponent implements OnInit {
 
  requestForm: FormGroup;
  title: string;
  questionType_selected: any;
  types_arr: any;

  public singleDate: any;


  constructor(private itemService: ItemService,private router: Router, private _fb: FormBuilder, private afs: AngularFirestore, private authService: AuthService) { }

 

  ngOnInit() {

    let parameters:any = { section_name: 'Brand Audit', page_name: 'Request'}
      this.itemService.logEvent('onPageView', parameters);

    // if (this.authService.currentUser !== 'Admin') {
    //   this.router.navigate(['/home'])
    // }

    var d = new Date();
    var n = 'query_' + d.getTime();

    this.requestForm = this._fb.group({
      'query_id': n,
      'username': ['', Validators.required],
      'company_name': ['', Validators.required],
      'department': ['', Validators.required],
      'designation': ['', Validators.required],
      'cell_number': ['', Validators.required],
      'email': ['', Validators.required],
      'query': ['', Validators.required],
    });
  }

  onSubmit() {
    var d = new Date();
    var n = 'query_' + d.getTime();

    if (this.requestForm.valid) {

       const queryData = this.requestForm.value;
       

       queryData.query_id = n;
       queryData.user_id = this.authService.currentUserId;
       queryData.client_name = this.authService.loggedInUserClient;
       queryData.createdDate = d;

    var setDoc = this.afs.collection('queries').doc(queryData.query_id).set(queryData);
   alert("Your query has been saved");

   let parameters:any = { 
    section_name: 'Queries',
    page_name: 'Query',
    query_id: queryData.query_id,
  }
  this.itemService.logEvent('OnQueryFormSubmission', parameters);

  this.router.navigateByUrl('/home');
 ///this.router.navigateByUrl('/calendar/list-post/' + this.doc_id);
 
  }
 
  }
 
 
}


// WEBPACK FOOTER //
// ./src/app/query-form/query-form.component.ts